import React from 'react';
import UserDashboardJobRequest from 'components/UserDashboard/UserDashboardJobRequest/UserDashboardJobRequest';

const UserDashboardRequestToJob = () => <UserDashboardJobRequest />;

export default UserDashboardRequestToJob;
